
<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><a class="link-effect" [routerLink]="['/solicitudes', 'revision']">Mis Solicitudes - Revisión</a></li>
                <li><span class="link-effect">Validar Solicitud</span></li>
            </ol>
        </div>
    </div>
  </div>
  <div class="content">
    <div class="block">
        <div class="block-header">
            <h3 class="block-title">Validar Solicitud</h3>
        </div>
  
        <div class="block-content">
          <app-solicitud-master-progress [model]="itemSolicitud" [data]="itemSolicitud" [flujoCompleto]="itemSolicitud.aplicaPersonas"></app-solicitud-master-progress>
          <app-solicitud-master-readonly [model]="itemSolicitud"></app-solicitud-master-readonly>
        </div>

        <!-- <div class="block-content">
          <mat-divider class="engie-divider"></mat-divider>
        </div> -->

        <div class="block-content">
          <mat-divider class="engie-divider"></mat-divider>
          <mat-accordion class="seccion-solicitud" multi>
            <mat-expansion-panel [expanded]="expandPersonal">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Personal
                </mat-panel-title>
              </mat-expansion-panel-header>   
              <div class="form-horizontal">
                <div class="form-group">
                  <div class="col-sm-6 text-left">
                    <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaPersonas" class="aplica" disabled>
                      <span *ngIf="itemSolicitud.aplicaPersonas">SI REQUIERE PERSONAS</span><span *ngIf="!itemSolicitud.aplicaPersonas">NO REQUIERE PERSONAS</span>
                    </mat-slide-toggle>
                  </div>      
                </div>
              </div>    
              <div class="form-horizontal" *ngIf="itemSolicitud.aplicaPersonas">
                <div class="form-group">
                  <div class="col-sm-6 text-left">
                    <div class="col-sm-2 text-left"><label class="control-label">Avance revisión:</label></div>
                    <div class="col-sm-6 text-left"><mat-progress-bar [value]="avanceRevisionPersonas" [bufferValue]="avanceRevisionPersonas"></mat-progress-bar>  </div>
                    <div class="col-sm-2 text-left"><label class="control-label">{{avanceRevisionPersonas.toFixed(0)}} %</label></div>
                  </div>
              </div>
            </div>                      
              <div class="table-responsive">
                <table mat-table #tablePersonal [dataSource]="itemSolicitud.personas" class="table table-striped table-vcenter">
                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let element">{{ element.nombres + ' ' +element.apellidoPaterno + ' ' + element.apellidoMaterno }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="dni">
                    <th mat-header-cell *matHeaderCellDef>Nro Documento Identidad</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.nroDocumentoIdentidad }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="cargo">
                    <th mat-header-cell *matHeaderCellDef>Cargo</th>
                    <td mat-cell *matCellDef="let element">{{ element.cargo }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="cantidad_documentos">
                    <th mat-header-cell *matHeaderCellDef>Cantidad de documentos</th>
                    <td mat-cell *matCellDef="let element" class="centre">{{ element.cantidad_documentos }}</td>
                  </ng-container>
          
                  <ng-container matColumnDef="estado">
                      <th mat-header-cell *matHeaderCellDef>Estado</th>
                      <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
                    </ng-container>
                  
                  <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                    <td mat-cell *matCellDef="let element"> 
                      <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogPersonal(element)">
                        <mat-icon>search</mat-icon>
                      </button>
                      <button mat-icon-button color="primary" aria-label="Eliminar" *ngIf="itemSolicitud.idEstado != 6 && itemSolicitud.idEstado != 2 && itemSolicitud.idEstado != 5 " (click)="deletePersona(element)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
          
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsPersonal"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsPersonal"></tr>
                </table>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="expandEquipos">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Equipos
                </mat-panel-title>
              </mat-expansion-panel-header>      
              <div class="form-horizontal">
                <div class="form-group">
                  <div class="col-sm-6 text-left">
                    <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaEquipos" class="aplica" disabled>
                      <span *ngIf="itemSolicitud.aplicaEquipos">SI REQUIERE EQUIPOS</span><span *ngIf="!itemSolicitud.aplicaEquipos">NO REQUIERE EQUIPOS</span>
                    </mat-slide-toggle>
                  </div>      
                </div>
              </div>    
              <div class="form-horizontal" *ngIf="itemSolicitud.aplicaEquipos">
                <div class="form-group">
                  <div class="col-sm-6 text-left">
                    <div class="col-sm-2 text-left"><label class="control-label">Avance revisión:</label></div>
                    <div class="col-sm-6 text-left"><mat-progress-bar [value]="avanceRevisionEquipos" [bufferValue]="avanceRevisionEquipos"></mat-progress-bar>  </div>
                    <div class="col-sm-2 text-left"><label class="control-label">{{avanceRevisionEquipos.toFixed(0)}} %</label></div>
                  </div>
                </div>
              </div>  

              <div class="table-responsive" *ngIf="itemSolicitud.aplicaEquipos">
                <table mat-table #tableEquipos [dataSource]="itemSolicitud.equipos" class="table table-striped table-vcenter">
                <!-- <ng-container matColumnDef="equipo">
                  <th mat-header-cell *matHeaderCellDef>Equipo</th>
                  <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
                </ng-container> -->
        
                <ng-container matColumnDef="marca">
                  <th mat-header-cell *matHeaderCellDef>Marca</th>
                  <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
                </ng-container>
        
                <ng-container matColumnDef="modelo">
                  <th mat-header-cell *matHeaderCellDef>Modelo</th>
                  <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
                </ng-container>
        
                <ng-container matColumnDef="serie">
                  <th mat-header-cell *matHeaderCellDef>Serie</th>
                  <td mat-cell *matCellDef="let element">{{ element.serie }}</td>
                </ng-container>
        
                <ng-container matColumnDef="estado">
                  <th mat-header-cell *matHeaderCellDef>Estado</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogEquipo(element)">
                      <mat-icon>search</mat-icon>
                    </button>  
                    <button mat-icon-button color="primary" aria-label="Eliminar" *ngIf="element.idEstado != 6 && element.idEstado != 2 && element.idEstado != 5 " (click)="deleteEquipo(element)">
                      <mat-icon>delete</mat-icon>
                    </button>                
                  </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipos"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipos"></tr>
                </table>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="expandVehiculos">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Vehículos
                </mat-panel-title>
              </mat-expansion-panel-header> 
              <div class="form-horizontal">
                <div class="form-group">
                  <div class="col-sm-6 text-left">
                    <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaVehiculos" class="aplica" disabled>
                      <span *ngIf="itemSolicitud.aplicaVehiculos">SI REQUIERE VEHÍCULOS</span><span *ngIf="!itemSolicitud.aplicaVehiculos">NO REQUIERE VEHÍCULOS</span>
                    </mat-slide-toggle>
                  </div>
                </div>                         
              </div>    
              <div class="form-horizontal" *ngIf="itemSolicitud.aplicaVehiculos">
                <div class="form-group">
                  <div class="col-sm-6 text-left">
                    <div class="col-sm-2 text-left"><label class="control-label">Avance revisión:</label></div>
                    <div class="col-sm-6 text-left"><mat-progress-bar [value]="avanceRevisionVehiculos" [bufferValue]="avanceRevisionVehiculos"></mat-progress-bar>  </div>
                    <div class="col-sm-2 text-left"><label class="control-label">{{avanceRevisionVehiculos.toFixed(0)}} %</label></div>
                  </div>
                </div>
              </div> 
              <div class="table-responsive" *ngIf="itemSolicitud.aplicaVehiculos">
                <table mat-table #tableVehiculos [dataSource]="itemSolicitud.vehiculos" class="table table-striped table-vcenter">
                <ng-container matColumnDef="marca">
                  <th mat-header-cell *matHeaderCellDef>Marca</th>
                  <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
                </ng-container>
        
                <ng-container matColumnDef="modelo">
                  <th mat-header-cell *matHeaderCellDef>Modelo</th>
                  <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
                </ng-container>
        
                <ng-container matColumnDef="placa">
                  <th mat-header-cell *matHeaderCellDef>Placa</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.placa }}</td>
                </ng-container>
        
                <ng-container matColumnDef="color">
                  <th mat-header-cell *matHeaderCellDef>Color</th>
                  <td mat-cell *matCellDef="let element">{{ element.color }}</td>
                </ng-container>
        
                <ng-container matColumnDef="anio">
                  <th mat-header-cell *matHeaderCellDef>Año</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.anio }}</td>
                </ng-container>
        
                <ng-container matColumnDef="chofer">
                  <th mat-header-cell *matHeaderCellDef>Chofer</th>
                  <td mat-cell *matCellDef="let element">{{ element.solicitudChofer.nombres + ' ' + element.solicitudChofer.apellidoPaterno + ' ' + element.solicitudChofer.apellidoMaterno }}</td>
                </ng-container>

                <ng-container matColumnDef="estado">
                  <th mat-header-cell *matHeaderCellDef>Estado</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
                </ng-container>
              
                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogVehiculo(element)">
                      <mat-icon>search</mat-icon>
                    </button>
                    <button mat-icon-button color="primary" aria-label="Eliminar" *ngIf="element.idEstado != 6 && element.idEstado != 2 && element.idEstado != 5 " (click)="deleteVehiculo(element)">
                      <mat-icon>delete</mat-icon>
                    </button>      
                  </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculos"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculos"></tr>
                </table>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="expandDocTecnica">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Documentación Técnica
                </mat-panel-title>
              </mat-expansion-panel-header> 
              <div class="form-horizontal">
                <div class="form-group">
                  <div class="col-sm-12 text-left">
                    <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaDocumentacionTecnica" class="aplica" disabled>
                      <span *ngIf="itemSolicitud.aplicaDocumentacionTecnica">SI REQUIERE DOCUMENTACIÓN TÉCNICA</span><span *ngIf="!itemSolicitud.aplicaDocumentacionTecnica">NO REQUIERE DOCUMENTACIÓN TÉCNICA</span>
                    </mat-slide-toggle>
                  </div>
                </div>

                <div class="form-group" *ngIf="itemSolicitud.aplicaDocumentacionTecnica">
                  <div class="col-sm-6 text-left">
                    <div class="col-sm-2 text-left"><label class="control-label">Avance revisión:</label></div>
                    <div class="col-sm-6 text-left"><mat-progress-bar [value]="avanceRevisionDocTecnica" [bufferValue]="avanceRevisionDocTecnica"></mat-progress-bar>  </div>
                    <div class="col-sm-2 text-left"><label class="control-label">{{avanceRevisionDocTecnica.toFixed(0)}} %</label></div>
                  </div>  
                  <div class="col-sm-6 text-right">
                    <!-- <a class="btn btn-new"
                      mat-raised-button
                      (click)="openDialogTipoDocumento(seccionDocumentacionTecnica)"><mat-icon>description</mat-icon> SOLICITAR NUEVO DOCUMENTO</a> -->
                  </div>
                </div>
              <div class="form-group" *ngIf="itemSolicitud.aplicaDocumentacionTecnica">
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <table mat-table #tableDocumentacionTecnica [dataSource]="itemSolicitud.documentosTecnicos" class="table table-striped table-vcenter">
                      <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                      </ng-container>
              
                      <ng-container matColumnDef="idRequisito">
                        <th mat-header-cell *matHeaderCellDef>Requisito</th>
                        <td mat-cell *matCellDef="let element" class="centre">{{ element.requisito }}</td>
                      </ng-container>
          
                      <ng-container matColumnDef="fechaVencimiento">
                        <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                        <td mat-cell *matCellDef="let element" class="centre">
                          {{ element.fechaVencimiento | date: "dd/MM/yyyy"}}
                        </td>
                      </ng-container>
          
                      <ng-container matColumnDef="idDocumento">
                        <th mat-header-cell *matHeaderCellDef>Doc.</th>
                        <td mat-cell *matCellDef="let element">
                          <a *ngIf="element.fileIsDeleted">Eliminado por Usuario</a>
                        <a *ngIf="!element.fileIsDeleted" (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                        </td>
                      </ng-container>
          
                      <ng-container matColumnDef="aprobado">
                        <th mat-header-cell *matHeaderCellDef>Aprobado</th>
                        <td mat-cell *matCellDef="let element"> 
                          <mat-slide-toggle 
                            [(ngModel)]="element.aprobado" 
                            (change)="changeAprobado(element)"
                            [disabled]="element.completado || itemSolicitud.idEstadoDocumentacionTecnica === 2"
                            >
                                      <!-- <p *ngIf="element.blnEstado"></p>
                                      <p *ngIf="!element.blnEstado"></p>                           -->
                          </mat-slide-toggle>
                        </td>
                      </ng-container>
            
                      <ng-container matColumnDef="observado">
                        <th mat-header-cell *matHeaderCellDef>Observado</th>
                        <td mat-cell *matCellDef="let element"> 
                          <mat-slide-toggle 
                            [(ngModel)]="element.observado" 
                            (change)="changeObservado(element)" 
                            [disabled]="element.completado || itemSolicitud.idEstadoDocumentacionTecnica === 2"
                            class="observado"
                            >
                                      <!-- <p *ngIf="element.blnEstado"></p>
                                      <p *ngIf="!element.blnEstado"></p>                           -->
                          </mat-slide-toggle>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <button mat-icon-button color="primary" aria-label="Eliminar" *ngIf="element.idEstado != 6 && element.idEstado != 2 && element.idEstado != 5 && element.nombreArchivo!=''"
                            (click)="deleteDocTecnico(element)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsDocumentacionTecnica"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsDocumentacionTecnica"></tr>
                    </table>
                  </div>
                </div>
              </div>

              <div class="form-group" *ngIf="itemSolicitud.aplicaDocumentacionTecnica && (itemSolicitud.idEstadoDocumentacionTecnica === 0 || itemSolicitud.idEstadoDocumentacionTecnica === 1)">
                <label class="col-md-1 control-label">Comentarios Doc. Técnica:</label>
                <div class="col-md-11">
                  <mat-form-field class="example-full-width" appearance="outline">
                    <mat-label>Comentarios Documentación Técnica</mat-label>
                    <textarea
                      matInput
                      placeholder="Comentarios"
                      rows="5"
                      [(ngModel)]="itemSolicitud.comentarioPorValidacionDocumentosTecnicos"
                      name="comentarioPorValidacionDocumentosTecnicos" [maxlength]="2000"
                      [disabled]="itemSolicitud.idEstadoDocumentacionTecnica === 2"
                    ></textarea>
                    
                  </mat-form-field>
                </div>
              </div>

              <div class="form-group sec-lnkcomentarios" *ngIf="itemSolicitud.logsDocumentacionTecnica.length > 0">
                <label class="col-md-1 control-label"></label>
                <div class="col-md-4">
                  <app-log-dialog-anchor [logs]="itemSolicitud.logsDocumentacionTecnica"></app-log-dialog-anchor>
                </div>
              </div>

              <div class="form-group" *ngIf="itemSolicitud.aplicaDocumentacionTecnica && (itemSolicitud.idEstadoDocumentacionTecnica === 0 || itemSolicitud.idEstadoDocumentacionTecnica === 1)">
                <div class="col-sm-12 text-right">
                  <a
                    class="btn btn-new"
                    mat-raised-button
                    (click)="guardarDocumentosTecnicos()"
                    ><mat-icon>description</mat-icon> Guardar Documentación Técnica</a
                  >
                </div>
              </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
            <!-- <mat-tab-group>
              <mat-tab label="Personal">  
  
              </mat-tab>
              <mat-tab label="Equipos"> 
              </mat-tab>
              <mat-tab label="Vehiculos">
              </mat-tab>
              <mat-tab label="Documentación Técnica">

              </mat-tab>
            </mat-tab-group> -->
        </div>      
        
        <div class="block-content">
          <mat-divider class="engie-divider"></mat-divider>
        </div>

        <div class="block-content" *ngIf="itemSolicitud.logs.length > 0">
          <div class="form-horizontal">
            <div class="form-group  sec-lnkcomentarios">
              <label class="col-md-1 control-label line-coments">Comentarios Solicitud:</label>
              <div class="col-md-4">
                <app-log-dialog-anchor [logs]="itemSolicitud.logs"></app-log-dialog-anchor>
              </div>
            </div>
          </div>
        </div>   
        
        <div class="block-content">
          <mat-divider class="engie-divider"></mat-divider>
        </div>

        <div class="block-content">
            <div class="form-horizontal">
              <div class="form-group">
                  <div class="col-sm-12 text-right">                    
                    <a class="btn btn-naranja2" mat-raised-button [routerLink]="['/solicitudes', 'revision']" ><mat-icon>exit_to_app</mat-icon> SALIR</a>
                  </div>
                </div>
            </div> 
        </div>
    </div>
  </div>
  
  <!-- <pre>{{itemSolicitud | json}}</pre> -->